//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import type { Draft, PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'
import { AlertCTO } from '@shared/AlertCTO'

const PREFIX = 'alertActions'

// Define a type for the slice state
export interface AlertState {
  alerts: AlertCTO[]
  modalMessage: string
  modalPage: string
}

// Define the initial state using that type
export const initialAlertState: AlertState = {
  alerts: [],
  modalPage: '',
  modalMessage: '',
}

export const AlertSlice = createSlice({
  name: PREFIX,
  initialState: initialAlertState,
  reducers: {
    addAlert: (state: Draft<AlertState>, action: PayloadAction<AlertCTO>) => {
      state.alerts.push(action.payload)
    },
    clearAlerts: (state: Draft<AlertState>) => {
      state.alerts = []
    },
    setModalMessage: (state: Draft<AlertState>, action: PayloadAction<{ page: string; message: string }>) => {
      state.modalMessage = action.payload.message
      state.modalPage = action.payload.page
    },
  },
})

export const alertActions = { ...AlertSlice.actions }

// export const selectUsdcBalance = (state: RootState): number | undefined => state.web3State.usdcBalance
//
export const AlertReducer = AlertSlice.reducer
export default AlertSlice
